
export function getRuteBackend() {
	return "";
}

export function getRuteLogin() {
	return "https://donhonesto.com/login";
	//return "http://localhost:3000/login";
}

export function getRuteTY_membership() {
	return "https://donhonesto.com/profesional/membresia/ty";
	//return "http://localhost:3000/profesional/membresia/ty";
}

export function getRuteHost() {
	return "https://donhonesto.com";
	//return "http://localhost:3000";
}

export function openViewCharge() {
	document.getElementById('screenBlackAll').style.display = "";
	document.getElementById('carga').style.display = "";
}

export function closeViewCharge() {
	document.getElementById('screenBlackAll').style.display = "none";
	document.getElementById('carga').style.display = "none";
}

export function createAlert(array) {
	let type = array.type;
	let msg_title = array.msg_title;
	let msg = array.msg;
	let effect = array.effect;
	let time_life = array.time_life;
	let post_action = array.post_action;

	let container_adv = document.getElementById("alertas-adv");
	let plantilla = document.getElementById('plantilla-advertencia-' + type);
	let advertencia = plantilla.cloneNode(true);
	advertencia.style.display = "";
	advertencia.style.animation = effect;
	advertencia.querySelector('.title-advertencia').innerHTML = msg_title;
	advertencia.querySelector('.subtitle-advertencia').innerHTML = msg;
	advertencia.setAttribute('action', post_action);

	container_adv.appendChild(advertencia);

	if (time_life) setTimeout(function () {
		let action = advertencia.getAttribute('action');
		if (action) {
			let button = document.createElement('button');
			button.setAttribute('onclick', action);
			button.click();
			button.remove();
		}

		advertencia.remove();
	}, time_life);
}

export function copyText(text) {
	let input = document.getElementById('copy-text-input');
	input.value = text;

	input.select();
	document.execCommand('copy');

	createAlert({ type: "success", msg_title: "Copiado", msg: "Se copio contenido en el portapapeles", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
}

export function isAuthenticated() {
    return !!localStorage.getItem('session_id') && !!localStorage.getItem('keylogin') && !!localStorage.getItem('code_confirm');
}

export function get_session_id() {
    return localStorage.getItem('session_id');
}

export function get_keylogin() {
    return localStorage.getItem('keylogin');
}

export function get_user() {
	if(localStorage.getItem('user'))
		return JSON.parse(localStorage.getItem('user'));
	else return [];
}

export async function validateSession() {
    let path_api = localStorage.getItem('path_api');
	
	await fetch(`${path_api}/account/validate_session.php`, {
		method: 'POST',
		headers: {'Content-Type': 'application/json'},
		body: JSON.stringify({
            rute: getRuteBackend(),
            session_id: get_session_id(),
            keylogin: get_keylogin(),
		}),
	}).then(function(response){
		if(response.ok){
			response.json().then(function(json){
				if(json.mensaje == "No hay una sesión iniciada" || json.mensaje == "No se encontró una sesión activa"){
					createAlert({
						type: "error",
						msg_title: "Error",
						msg: json.mensaje,
						effect: "opacidad 1s, desplazamiento 1s",
						time_life: 1000
					});
					localStorage.removeItem('session_id');
					localStorage.removeItem('keylogin');
					localStorage.removeItem('code_confirm');
					localStorage.removeItem('user');

					localStorage.removeItem('formDataSearch');
                    window.setTimeout(function(){
                        window.location.href = getRuteLogin();
                    }, 1000);
                }else if(json.mensaje == "success"){
					localStorage.setItem('user', JSON.stringify(json.user));
				}
			})
		}
	});
}